import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialMediaLinks = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Share2" size={16} className="text-primary" />
            <span className="text-xs md:text-sm font-medium text-primary">Stay Connected</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-3 md:mb-4">
            Connect With Us
          </h2>
          
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto">
            Get in touch with our team for inquiries, consultations, and partnership opportunities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaLinks;